const selectStyles: any = {
  // clearIndicator: (provided: any, state: any) => ({
  //   ...provided
  // }),
  container: (provided: any, state: any) => ({
    ...provided
  }),
  control: (provided: any, state: any) => ({
    ...provided, 
    minHeight: '0',
    borderTop: '0', 
    borderLeft: '0', 
    borderRight: '0', 
    borderBottom: 'solid 2px', 
    borderBottomColor: state.isFocused ? '#1a1a1a' : '#c4c4c4',
    borderRadius: '0', 
    boxShadow: 'none',
    cursor: 'pointer', 
    background: 'transparent', 
    '&:hover': {
      borderColor: '#1a1a1a'
    }
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    paddingRight: 0,
    '& svg': {
      fill: '#1a1a1a', 
      width: 17,
      height: 17
    }
  }),
  group: (provided: any, state: any) => ({
    ...provided
  }),
  groupHeading: (provided: any, state: any) => ({
    ...provided
  }),
  indicatorsContainer: (provided: any, state: any) => ({
    ...provided, 
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    ...provided, 
    display: 'none'
  }),
  input: (provided: any, state: any) => ({
    ...provided, 
    margin: '0',
    padding: '0', 
    lineHeight: '1.4em',
    fontSize: '18px'
  }),
  loadingIndicator: (provided: any, state: any) => ({
    ...provided
  }),
  loadingMessage: (provided: any, state: any) => ({
    ...provided
  }),
  menu: (provided: any, state: any) => ({
    ...provided, 
    zIndex: '30'
  }),
  menuList: (provided: any, state: any) => ({
    ...provided
  }),
  menuPortal: (provided: any, state: any) => ({
    ...provided
  }),
  multiValue: (provided: any, state: any) => ({
    ...provided
  }),
  multiValueLabel: (provided: any, state: any) => ({
    ...provided
  }),
  multiValueRemove: (provided: any, state: any) => ({
    ...provided
  }),
  noOptionsMessage: (provided: any, state: any) => ({
    ...provided
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    cursor: 'pointer'
  }),
  placeholder: (provided: any, state: any) => {
    const focusStyles = state.isFocused ? {
      transition: 'top 0.25s', 
      top: "-0.8em", 
      fontSize: '12px'
    } : {}
    return {
      ...provided, 
      ...focusStyles,  
      margin: '0', 
      color: '#666'
    }
  },
  singleValue: (provided: any, state: any) => {
    const focusStyles = state.isFocused ? {
      transition: 'top 0.25s', 
      top: "-0.8em", 
      fontSize: '12px'
    } : {}
    const val = state.getValue();
    const hasVal = val.length && val[0].value;
    return {
      ...provided, 
      ...focusStyles, 
      fontSize: 18,
      color: hasVal ? '#1a1a1a' : '#666'
    }
  },
  valueContainer: (provided: any, state: any) => ({
    ...provided, 
    overflow: 'visible', 
    padding: 0,
    margin: 0, 
    '& input': {
      border: '0 !important'
    }
    // padding: '8px 0' // only for searchable
  }),

}
export default selectStyles